module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "bid-alerts-view grid-list-md pl-3 pr-3 pb-5",
    staticStyle: {
      "padding-top": "70px",
      "max-width": "1442px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-2": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "page-header-body",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto",
      "margin": "0px"
    }
  }, [_vm._v("\n          Federal Bid Alert Settings\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticClass: "page-header-subtext page-subtitle",
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px",
      "margin": "0px"
    }
  }, [_vm._v("\n            Use the options below to setup your Federal Bid Email Alert Settings.\n          ")])])]), _vm._v(" "), (_vm.loadingAlerts) ? _c('v-flex', {
    staticClass: "flex-center pa-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "80",
      "indeterminate": ""
    }
  })], 1) : _c('v-flex', {
    staticStyle: {
      "padding": "4px"
    },
    attrs: {
      "xs12": "",
      "mt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    on: {
      "click": _vm.savingSettings
    }
  }, [_vm._v("Save settings")])], 1)], 1), _vm._v(" "), (!_vm.loadingAlerts) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('BidAlertSelect', {
    attrs: {
      "label": "Agency",
      "items": _vm.agencies
    },
    model: {
      value: (_vm.filters.agency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "agency", $$v)
      },
      expression: "filters.agency"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('BidAlertSelect', {
    attrs: {
      "label": "NAICS",
      "items": _vm.naicsCodes
    },
    model: {
      value: (_vm.filters.naics),
      callback: function($$v) {
        _vm.$set(_vm.filters, "naics", $$v)
      },
      expression: "filters.naics"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('BidAlertSelect', {
    attrs: {
      "label": "PSC",
      "items": _vm.pscCodes
    },
    model: {
      value: (_vm.filters.psc),
      callback: function($$v) {
        _vm.$set(_vm.filters, "psc", $$v)
      },
      expression: "filters.psc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('BidAlertSelect', {
    attrs: {
      "label": "Set-Aside",
      "items": _vm.setAsides
    },
    model: {
      value: (_vm.filters.setAside),
      callback: function($$v) {
        _vm.$set(_vm.filters, "setAside", $$v)
      },
      expression: "filters.setAside"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('BidAlertSelect', {
    attrs: {
      "label": "Notice Type",
      "items": _vm.noticeTypes
    },
    model: {
      value: (_vm.filters.noticeType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "noticeType", $$v)
      },
      expression: "filters.noticeType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('BidAlertSelect', {
    attrs: {
      "label": "Point Of Contact",
      "items": _vm.pointOfContacts,
      "uri": _vm.pointOfContactURI,
      "async": ""
    },
    model: {
      value: (_vm.filters.pointOfContact),
      callback: function($$v) {
        _vm.$set(_vm.filters, "pointOfContact", $$v)
      },
      expression: "filters.pointOfContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "keywords-box",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "chips": "",
      "autocomplete": "",
      "placeholder": "Keywords (Type keyword and press enter to add)",
      "solo": "",
      "tags": "",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [(data.item) ? _c('v-chip', {
          attrs: {
            "selected": data.selected,
            "label": "",
            "small": ""
          }
        }, [_c('span', {
          staticClass: "pr-2"
        }, [_vm._v("\n                " + _vm._s(data.item) + "\n              ")]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return data.parent.selectItem(data.item)
            }
          }
        }, [_vm._v("close")])], 1) : _vm._e()]
      }
    }], null, false, 2664600704),
    model: {
      value: (_vm.filters.keywords),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keywords", $$v)
      },
      expression: "filters.keywords"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f319552","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ManageFederalBidAlertView.vue
// module id = 1709
// module chunks = 29